import { DEPARTMENT_REPORTS } from "../../actions/types";
const initialState = {
  items: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case DEPARTMENT_REPORTS:
      return {
        ...state,
        items: action.payload
      };
    default:
      return state;
  }
}
